import { render, staticRenderFns } from "./PoiCard.vue?vue&type=template&id=9cb1e95e&"
import script from "./PoiCard.vue?vue&type=script&lang=ts&"
export * from "./PoiCard.vue?vue&type=script&lang=ts&"
import style0 from "./PoiCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports